import { AlertOctagonOutlineIcon } from './AlertOctagonOutlineIcon';

/**
 * author: Peter Noble
 * id 90994A54-72AA-498F-8806-AAD466CC21BD
 * name alert-octagon-outline
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alert-octagon-outline.svg
 * tags
 * - Alert / Error 
 */
export const WarningOctagonOutlineIcon = AlertOctagonOutlineIcon;
export default WarningOctagonOutlineIcon